import * as cr from "./_cr";
//import * as cs from "./_ca";
//import * as hf from "./_hf";
import * as ht from "./_ht";

import { a } from "./_csAbt";
//import * as ls from "./_csLcl";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as SrlC from "./_ccbSrlC";

import * as IptC from "./_ccbIptC";

import { useMdlz } from "./_csMdl";

let $word = '';

export const useMdlSchz = () => {
  const _sMdlz = useMdlz();
//  const _udtThis = ls.udtThis();
  const _show = (pz: {
    ls?: ht.ls,
    onPrs: ( _dz: ht.dz ) => void,
    bUdt?: ht.b, 
  }) => {
    if (pz.bUdt != true)$word = '';
    const _dw = cr.d('p') ? 60 : 40;
    const _ls = [
      cr.c(BoxC.N, {
        key: -10,
        boxStlz: a(`br/1 dw/${_dw} dh/70 fd/csc p/1 sc/lt1`), // dhx でなく dh
        oClds: [
          cr.c(BoxC.N, {
            key: -10,
            boxStlz: a(`dw/f fd/rsc mb/2`),
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                boxStlz: a(`f/1`),
                cz: {
                  bEdit: true,
                  iptType: 'text',
                  vle: $word,
                  onChg: (_s: ht.s) => {
                    $word = _s;
                  }
                }
              }),
              cr.c(BtnC.N, {
                key: -20,
                boxStlz: a(`br/1 dw/10 fd/rcc ml/0.5 pv/0.5 sc/lt5`),
                pslPtyz: {
                  onPress: () => {
                    _show({ ... pz, bUdt: true }); // 再描画
                  },
                },
                bfrIconCz: {
                  iconPtyz: a("icc/lt1 icn/search ics/2"),
                },
                lblCz: {
                  boxStlz: a(`ml/0.5`),
                  textz: {
                    pfx: '検索',
                    stlz: a(`tc/lt1`),
                  },
                },
              }),
            ]
          }),
          cr.c(BoxC.N, {
            key: -20,
            boxStlz: a(`dw/f f/1 fd/css`),
            oClds: [
              cr.c(SrlC.V, {
                key: -10,
                oClds:
//                  pz.ls?.filter((_dz: ht.dz) => $word == '' || _dz.pfx.indexOf($word) >= 0)
                  pz.ls?.filter((_dz: ht.dz) => $word == '' || (_dz.sch && _dz.sch?.indexOf($word) >= 0))
                  .map((_dz: ht.dz, _idx: ht.n) => (
                    cr.c(BtnC.N, {
                      key: _idx,
                      boxStlz: a(`bc/lt5 bs/ds bwt/${_idx == 0 ? 0 : 0.5} dw/${_dw - 2} fd/rsc pv/1 ph/1`),
                      pslPtyz: {
                        onPress: () => {
                          if (pz.onPrs) pz.onPrs(_dz);
                          _sMdlz.set({
                            bShow: false,
                          });
                        },
                      },
                      lblCz: {
    //                    boxStlz: a(`dw/f`),
                        textz: {
                          pfx: _dz.pfx,
                          ptyz: a(`tn/1`),
                        },
                      },
                    })
                  ))
              })
            ]
          })
        ]
      })
    ];
    //hf.l('ipt 44: here');
    _sMdlz.set({
      bShow: true,
      oClds: _ls
    })
  }
  return {
    show: _show
  }
};
